import React from "react"
import { useTranslation } from "react-i18next"
import { formatVars } from "../../helpers/translation"

const FileCountDisplay = ({ className, fileCount }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation("generic")

  return (
    <span className={className}>
      {formatVars(language, t("##.Timeline.FileCount"), {
        NUM: fileCount,
      })}
    </span>
  )
}

export default FileCountDisplay
